import { types, unprotect } from 'mobx-state-tree'
import { ForDirectExtend } from '../../features/mobx'
import { IProfile, Profile } from './registry/ProfileRegistry'

const _Auth = types
  .model({
    user: types.maybeNull(Profile),
    isLoggingIn: types.boolean,
    isLoggedIn: types.boolean,
    isUserLoading: types.boolean
  })
  .named('auth')
  .views((self) => ({}))
  .actions((self) => {
    function afterCreate() {
      unprotect(self)
    }
    function setUser(user: IProfile) {
      self.user = user
    }

    function setIsLoggedIn(isLoggedIn: boolean) {
      self.isLoggedIn = isLoggedIn
    }

    function setIsLoggingIn(isLoggingIn: boolean) {
      self.isLoggingIn = isLoggingIn
    }

    function setIsUserLoading(isUserLoading: boolean) {
      self.isUserLoading = isUserLoading
    }

    return {
      afterCreate,
      setUser,
      setIsLoggedIn,
      setIsLoggingIn,
      setIsUserLoading
    }
  })

interface AuthType extends ForDirectExtend<typeof _Auth> {}
export const Auth: AuthType = _Auth

const AuthStore = Auth.create({
  user: null,
  isLoggingIn: false,
  isLoggedIn: false,
  isUserLoading: false
})

export default AuthStore
